<ng-container *transloco="let t;">
<div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t("Content Library (general) - Content Library")}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body px-0" tabindex="0">
        <div class="content-library-tab-content mt-50">
        <div class="px-1">
            <div class="input-group input-group-merge mb-50 mt-25">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i data-feather="search"></i></span>
                </div>
                <input
                    type="text"
                    class="form-control"
                    [placeholder]='t("Search (general) - Search")'
                    aria-label="Search..."
                    aria-describedby="basic-addon-search2"
                    [(ngModel)]="searchContent"
                />
            </div>
        </div>
        <app-skeleton *ngIf="(fetchContentLibraryRequestState | async) === 'BUSY'" [section]="'content-library'" [loop]="0"></app-skeleton>
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="content-library-tab-scroll">
            <div class="editorTabScroll" *ngIf="(fetchContentLibraryRequestState | async) === 'DONE'">
                <div class="content-library-area px-0 mt-1">
                    @for (content of (allContents | async | searchFilterPipe: searchContent : 'name'); track content) {
                        <div class="content-library-items" (click)="selectContentLibrary(content)">
                            <div class="content-library-img-box">
                                <ng-container *ngIf="content.thumbnail; else noThumbnail">
                                        <img draggable="false" [src]="content.id | thumbnail: 'content-libraries'" alt="" height="150" width="150" />
                                </ng-container>
                                <ng-template #noThumbnail>
                                    <div class="no-thumbnail"></div>
                                </ng-template>
                            </div>
                            <div class="content-library-title-box">
                                <h3>{{content.name}}</h3>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </ng-scrollbar>
        </div>
    </div>
</ng-container>